<mat-tree #tree [dataSource]="dataSource" [treeControl]="treeControl">
	<!-- This is the tree node template for leaf nodes -->
	<mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle matTreeNodePadding>
		<!-- use a disabled button to provide padding for tree leaf -->
		<button mat-icon-button (click)="applySelectionItem(node)">
			{{ node.name }}
			<span class="badget">
				<app-badge-station *ngIf="showBadges" [mergedStation]="node.value"></app-badge-station>
			</span>
		</button>
	</mat-tree-node>
	<!-- This is the tree node template for expandable nodes -->
	<mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding>
		<button
			data-testid="toggle-button"
			mat-icon-button
			matTreeNodeToggle
			[attr.aria-label]="'Toggle ' + node.name"
		>
			<mat-icon class="mat-icon-rtl-mirror">
				{{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
			</mat-icon>
		</button>
		{{ node.name }}
	</mat-tree-node>
</mat-tree>
